import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import store from 'store/store';

import App from 'components/app';

import 'styles/main.scss';
import { createMuiTheme } from '@material-ui/core/styles';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';


const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#E98300', //orange
      neutral: '#9B9B9B',
      darkNeutral: '#4A4A4A'
    },
    secondary: {
      main: '#FFFFFF', //white
      accent: '#4EA4FF' //blue on info bubble
    }
  },
  typography: {
    useNextVariants: true,
    color: '#00000A',
    fontFamily: ['Open Sans', 'Roboto']
  },
  breakpoints: {
    sm: 700
  },
  overrides: {
    MuiButton: {
      text: {
        background: '#E98300', //orange
        color: '#FFFFFF',
        // padding: '2px 10px',
        textTransform: 'none' //removes capital casing for button label
      },
    },
    // MuiTypography: {
    //   h1: {
    //     color: config.themeConfig.welcomeTitle,
    //     fontSize: '32px',
    //   },
    //   h2: {
    //     color: config.themeConfig.buttonText,
    //     fontSize: '20px',
    //   },
    //   h6: {
    //     color: config.themeConfig.appTitle,
    //   },
    //   h5: {
    //     color: config.themeConfig.primaryColor,
    //   }
    // }
  }
});

const renderApp = Component => {
  render(
    <Provider store={store}>
       <MuiThemeProvider theme={theme}>
        <Component />
      </MuiThemeProvider>
    </Provider>,
    document.getElementById('app-container')
  );
};

renderApp(App);
